import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Shield, Lock } from 'lucide-react';
export const Offer = () => {
  return <section id="offer" className="py-12 md:py-24 bg-brand-darker relative border-t border-brand-red/20" data-id="element-108">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-red/10 via-brand-darker to-brand-darker pointer-events-none" data-id="element-109"></div>

      <div className="max-w-3xl mx-auto px-4 text-center relative z-10" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-5 md:space-y-8" data-id="element-111">
          <h2 className="font-display text-4xl md:text-7xl text-white uppercase leading-none" data-id="element-112">
            Recupera el <span className="text-brand-red" data-id="element-113">Control</span>
          </h2>

          <p className="text-base md:text-xl text-brand-light" data-id="element-114">
            No permitas que un doble check azul decida tu estado de ánimo. Obtén
            "El Código del Visto" por una fracción de lo que gastarías en una
            cita fallida.
          </p>

          <div className="py-4 md:py-8" data-id="element-115">
            <div className="inline-block border-2 border-brand-red p-5 md:p-8 bg-brand-dark shadow-glow-red" data-id="element-116">
              <p className="text-brand-gray uppercase tracking-widest text-xs md:text-sm font-bold mb-1 md:mb-2" data-id="element-117">
                Inversión Única
              </p>
              <p className="font-display text-5xl md:text-6xl text-white" data-id="element-118">
                $87{' '}
                <span className="text-xl md:text-2xl text-brand-red" data-id="element-119">MXN</span>
              </p>
            </div>
          </div>

          <div className="space-y-4 md:space-y-6" data-id="element-120">
            <CTAButton href="https://serenopulse.com/cart/47705664684290:1" className="w-full md:w-auto text-lg md:text-2xl py-4 md:py-5 px-8 md:px-12" data-id="element-121">
              ¡Quiero recuperar el poder ahora!
            </CTAButton>

            <div className="flex items-center justify-center space-x-4 md:space-x-6 text-brand-gray text-xs md:text-sm" data-id="element-122">
              <div className="flex items-center" data-id="element-123">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5 md:mr-2" data-id="element-124" />{' '}
                Pago Seguro
              </div>
              <div className="flex items-center" data-id="element-125">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5 md:mr-2" data-id="element-126" />{' '}
                Acceso Inmediato
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};